import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Spin, Empty, Pagination, Flex, Card, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { fetchAllFeedbacks } from '../../store/feedbackSlice';
import { PageWrapper, Title, Description } from './feedback.styles';
const FeedbackPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const pageSize = 10;
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    const feedbacksData = useSelector((state) => state?.feedback?.feedbacks);
    const { loading, response } = feedbacksData;
    // Fetch all feedbacks on component mount
    useEffect(() => {
        if (siteId) {
            dispatch(fetchAllFeedbacks({ siteId, pageNumber: 0, pageSize }));
        }
    }, [siteId, dispatch]);
    const handlePageChange = (page) => {
        setCurrentPage(page);
        dispatch(fetchAllFeedbacks({ siteId: siteId || '', pageNumber: page - 1, pageSize }));
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '12%',
            render: (text) => _jsx("span", { children: text || '-' }),
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
            width: '40%',
            render: (text) => (_jsx("div", { style: { wordBreak: 'break-word', maxHeight: '100px', overflow: 'auto' }, children: text || '-' })),
        },
        {
            title: 'Phone Number',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: '15%',
            render: (text) => _jsx("span", { children: text || '-' }),
        },
        {
            title: 'Rating',
            dataIndex: 'rating',
            key: 'rating',
            width: '10%',
            render: (rating) => {
                let color = '#f5222d';
                if (rating >= 4)
                    color = '#52c41a';
                else if (rating >= 3)
                    color = '#faad14';
                return (_jsxs("span", { style: { color, fontWeight: 600 }, children: [rating, "/5 \u2B50"] }));
            },
        },
    ];
    return (_jsxs(PageWrapper, { children: [_jsxs(Flex, { align: "center", gap: 12, style: { marginBottom: '24px' }, children: [_jsx(Button, { type: "text", icon: _jsx(ArrowLeftOutlined, {}), onClick: () => navigate('/editor'), style: { padding: 0 } }), _jsx(Title, { children: "Feedbacks" })] }), _jsx(Card, { style: { marginBottom: '24px' }, children: _jsx(Description, { children: "All customer feedbacks are displayed below with pagination." }) }), _jsx(Card, { children: loading ? (_jsx("div", { style: { display: 'flex', justifyContent: 'center', padding: '40px' }, children: _jsx(Spin, { size: "large" }) })) : response && response.content && response.content.length > 0 ? (_jsxs(_Fragment, { children: [_jsx(Table, { columns: columns, dataSource: response.content.map((item, index) => ({
                                ...item,
                                key: item.feedbackId || index,
                            })), pagination: false, size: "middle", scroll: { x: 1000 }, style: { marginBottom: '16px' } }), _jsxs(Flex, { justify: "space-between", align: "center", children: [_jsxs("span", { style: { color: '#666' }, children: ["Showing ", (currentPage - 1) * pageSize + 1, " to", ' ', Math.min(currentPage * pageSize, response.totalElements), " of", ' ', response.totalElements, " feedbacks"] }), _jsx(Pagination, { current: currentPage, pageSize: pageSize, total: response.totalElements, onChange: handlePageChange, showSizeChanger: false })] })] })) : (_jsx(Empty, { description: "No feedbacks available", style: { padding: '40px' } })) })] }));
};
export default FeedbackPage;
